import {ACTION_CODE} from './_actionCode';
import {ProductionService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'GET_PRODUCTIONS_GROUPED_BY_DEAL';

export async function getProductionsGroupedByDeal(
    userData: Record<string, string>,
    before: string,
    after: string,
    query = ''
) {
    try {
        LoggerService.logInfo('Action - getProductionsGroupedByDeal - Start');

        const getProductionsGroupedByDealResult = await ProductionService.getProductionsGroupedByDeal(userData, before, after, query);

        const {data, metadata} = getProductionsGroupedByDealResult;
        
        LoggerService.logInfo('Action - getProductionsGroupedByDeal - End - Success');

        return ResultModel.newSuccessResult(data, metadata);

    }
    catch (error) {
        LoggerService.logInfo('Action - getProductionsGroupedByDeal - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}